import React from 'react'
import { useTranslation } from 'react-i18next';
interface LangTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  lngKey: string
}
const LangText = ({ children, lngKey, ...props }: LangTextProps) => {
  const { t } = useTranslation();
  return <span lng-key={lngKey} {...props}>{children ? children : t(lngKey)}</span>
}

export { LangText }